import { Dayjs, OpUnitType } from 'dayjs'

import { isBefore } from './isBefore'

/**
 * Gets the earliest of the two datetimes.
 */
export function earliest(a: Dayjs, b: Dayjs, unit?: OpUnitType) {
    if (isBefore(a, b, unit)) {
        return a
    }
    return b
}
